// GENERATED by npm run update:prepare. Edit updates/*/releases instead.
export const FRONTEND_VERSION = "1.0.51";
export const FRONTEND_UPDATE_HISTORY = [
  {
    "file": "1.0.51.json",
    "version": "1.0.51",
    "releasedAt": "2026-11-04",
    "required": true,
    "notes": [
      "Master user tampil baru: Kelola User & Akses — daftar user di kiri (cari, filter Admin/HRD/Lainnya & lokasi, progress jumlah menu, chip akses), form di kanan.",
      "Form 4 bagian: Identitas, Role & lokasi, Akses menu (kartu per kelompok, centang grup, preset HRD / Admin lokasi, cari menu, dipilih saja), Akses form absen.",
      "Tambah user langsung dari halaman ini (password + Acak), Salin akses dari user lain, Export Matriks akses ke CSV."
    ]
  },
  {
    "file": "1.0.50.json",
    "version": "1.0.50",
    "releasedAt": "2026-11-04",
    "required": true,
    "notes": [
      "Master user: untuk user ber-role Admin / HRD kini bisa dipilih menu apa saja yang diakses (Ikuti role, atau Pilih menu: Panel, Approval, Tambah user, Master user, Import mesin, Rekap, GPS, Info HRD, dll.).",
      "Menu Admin Panel, tombol Panel & Approval di beranda, dan layar Rekap mengikuti menu per user. Daftar Master user menampilkan badge 'menu khusus'."
    ]
  },
  {
    "file": "1.0.49.json",
    "version": "1.0.49",
    "releasedAt": "2026-11-04",
    "required": true,
    "notes": [
      "Admin Panel > Pengguna > Master user (menggantikan Reset password user): daftar user dengan filter lokasi & role, badge role/lokasi/jumlah form.",
      "Edit user: nama, ID finger, payroll, divisi, perusahaan, status, email atasan, ROLE (dari Master role), LOKASI, dan AKSES FORM. Reset password tetap di layar yang sama.",
      "Admin Jakarta hanya melihat & mengubah user Jakarta; user bertingkat Admin terkunci (khusus Admin pusat)."
    ]
  },
  {
    "file": "1.0.48.json",
    "version": "1.0.48",
    "releasedAt": "2026-11-04",
    "required": true,
    "notes": [
      "Role baru Admin Jakarta (admin_jkt): melihat & mengelola karyawan Jakarta saja — Rekap/Koreksi, Approval, Riwayat, Respon Laporan, Tambah/Reset user, Dashboard GPS. Menu pengaturan global (import mesin, master role, periode, geofence, perangkat, wajah, log login, sinkron GSheet) disembunyikan.",
      "Tambah User: role yang dipilih di form kini benar-benar tersimpan (sebelumnya user baru tersimpan sebagai admin).",
      "Absen online: telat memakai toleransi 10 menit seperti mesin (masuk 08:31–08:40 untuk jam mulai 08:30 tetap Hadir)."
    ]
  },
  {
    "file": "1.0.47.json",
    "version": "1.0.47",
    "releasedAt": "2026-10-31",
    "required": true,
    "notes": [
      "Admin Panel > Akses absen & geofence: pilihan akses absen per karyawan — Online + mesin (bawaan), Online saja, atau Mesin saja. Bisa juga diterapkan ke satu divisi sekaligus.",
      "Mode Mesin saja: tombol absen Masuk/Pulang di aplikasi tidak ditampilkan.",
      "Data Absen: absen online dan mesin kini dibaca bersama. Contoh: masuk lewat aplikasi 08:17 + pulang di mesin 12:32 tampil sebagai Masuk 08:17 / Pulang 12:32 (Hadir), bukan lagi 'Tidak Absen Pulang'. Di bawah jam ada keterangan 'via aplikasi' / 'via mesin'."
    ]
  },
  {
    "file": "1.0.46.json",
    "version": "1.0.46",
    "releasedAt": "2026-10-28",
    "required": false,
    "notes": [
      "Dashboard GPS: tinggi peta di tab Peta dikecilkan menjadi setengahnya (29% tinggi layar, minimal 220 px), sehingga daftar karyawan lebih cepat terlihat."
    ]
  },
  {
    "file": "1.0.45.json",
    "version": "1.0.45",
    "releasedAt": "2026-10-25",
    "required": false,
    "notes": [
      "Rekap Absensi: tanda proses yang jelas — garis berjalan di bawah header dan pil \"Memuat data rekap… N dtk\" selama data dimuat, diperbarui, koreksi disimpan/dihapus, atau histori koreksi dimuat.",
      "Kartu angka (Total Pegawai, Cuti, Sakit, Ijin, Alpa, Terlambat, Koreksi) menampilkan penanda memuat, bukan angka 0, sebelum data datang. Tombol muat ulang ikut berputar saat penyegaran di belakang layar."
    ]
  },
  {
    "file": "1.0.44.json",
    "version": "1.0.44",
    "releasedAt": "2026-10-24",
    "required": false,
    "notes": [
      "Admin Panel > Data > Bebas absen & karyawan harian: daftar Karyawan harian (MOH. RIZAL 585, ROCKY ADAM FARISI 587, ABI KELUT WIBOWO 670). HARI KERJA mereka di file DB_ABSEN = jumlah hari masuk."
    ]
  },
  {
    "file": "1.0.43.json",
    "version": "1.0.43",
    "releasedAt": "2026-10-24",
    "required": false,
    "notes": [
      "Sinkron GSheet: hari SEBELUM TGL MASUK karyawan (dibaca dari sheet ABSENSI file DB_ABSEN) yang oleh mesin ditandai Alpa tanpa scan tidak lagi ditulis ke db1-absen, dan di ABSENSI-email dibiarkan kosong (bukan O). Karyawan baru tidak lagi mendapat HARI KERJA minus (mis. -18 menjadi 4)."
    ]
  },
  {
    "file": "1.0.42.json",
    "version": "1.0.42",
    "releasedAt": "2026-10-24",
    "required": false,
    "notes": [
      "Admin Panel > Data > Karyawan bebas absen mesin: master karyawan yang tidak wajib absen di mesin. Hari kerja tanpa scan (Alpa dari mesin) otomatis menjadi NF dan dihitung masuk.",
      "Simbol NF kini berarti \"Bebas absen mesin (masuk)\": masuk hitungan Hadir di Data Mesin & dashboard, tidak lagi di kelompok \"Perlu cek\". Filter simbol Rekap punya pilihan NF."
    ]
  },
  {
    "file": "1.0.41.json",
    "version": "1.0.41",
    "releasedAt": "2026-10-24",
    "required": false,
    "notes": [
      "Admin Panel > Pengguna > Master role & lokasi akses: satu layar untuk mengatur role (kode, tingkat, lokasi yang dilihat, menu) dan master lokasi (nama baku + ejaan lain). Datanya di Supabase.",
      "Role baru HRD Surabaya (hrd_sby) dan HRD Jakarta (hrd_jkt): hanya melihat karyawan lokasinya di Riwayat, Approval, Respon Laporan, daftar karyawan, serta Rekap/Board/DB_FIX/ABSEN-EMAIL.",
      "HRD kini bisa membuka Panel (Rekap & Info HRD). Rekap untuk HRD bersifat lihat saja; koreksi dan sinkron GSheet tetap khusus Admin.",
      "Form Tambah User: pilihan Role diambil dari Master role."
    ]
  },
  {
    "file": "1.0.40.json",
    "version": "1.0.40",
    "releasedAt": "2026-10-24",
    "required": false,
    "notes": [
      "Data Mesin Fingerprint: hari ini yang di mesin masih tertulis Alpa tanpa scan masuk/pulang kini tampil sebagai \"Belum Absen\" (BLM, abu-abu), bukan Alpa. Setelah harinya lewat, status Alpa dari mesin kembali dipakai."
    ]
  },
  {
    "file": "1.0.39.json",
    "version": "1.0.39",
    "releasedAt": "2026-10-24",
    "required": false,
    "notes": [
      "Tidak ada perubahan frontend; menyamakan nomor versi dengan backend 1.0.39."
    ]
  },
  {
    "file": "1.0.38.json",
    "version": "1.0.38",
    "releasedAt": "2026-10-24",
    "required": false,
    "notes": [
      "ABSEN-EMAIL: tombol export Excel dengan format sama seperti tampilan (judul, kepala 3 baris tanggal/hari/ABSEN-TELAT, warna latar & huruf tiap sel, lebar kolom, kolom & kepala beku). Tombol GMS JKT khusus departemen GMS JKT; tombol Excel mengikuti filter yang sedang tampil.",
      "Pustaka ExcelJS dimuat hanya saat tombol ditekan (tidak menambah berat pembukaan aplikasi)."
    ]
  },
  {
    "file": "1.0.37.json",
    "version": "1.0.37",
    "releasedAt": "2026-10-24",
    "required": false,
    "notes": [
      "Board Absensi & Tabel Data (DB_FIX) di HP bisa digeser ke kanan lagi: kolom beku (376px & 430px) dulu lebih lebar dari layar sehingga kolom tanggal selalu tertutup. Di HP kini hanya kolom NAMA yang dibekukan; desktop tidak berubah.",
      "Board: kepala kartu ringkas di HP (keterangan pendek, tombol Excel Board)."
    ]
  },
  {
    "file": "1.0.36.json",
    "version": "1.0.36",
    "releasedAt": "2026-10-24",
    "required": false,
    "notes": [
      "ABSEN-EMAIL: legenda warna & nama sheet dihapus; tampilan HP lebih rapi (judul 2 baris, cari selebar layar, tombol ringkas, kolom kecil dilebarkan, di HP hanya kolom NAMA yang dibekukan).",
      "Rekapitulasi: Menampilkan data cukup menulis periode bila periode dipilih; tab aktif otomatis terlihat di bar tab HP."
    ]
  },
  {
    "file": "1.0.35.json",
    "version": "1.0.35",
    "releasedAt": "2026-10-24",
    "required": false,
    "notes": [
      "Rekapitulasi (Admin) tampilan HP lebih ringkas: header satu baris (tombol Excel pendek), tab berlabel singkat, filter periode dengan tanggal Dari/Sampai berdampingan, kartu angka 3 kolom, judul tabel + tombol Excel sebaris. Tampilan desktop tidak berubah."
    ]
  },
  {
    "file": "1.0.34.json",
    "version": "1.0.34",
    "releasedAt": "2026-10-24",
    "required": false,
    "notes": [
      "Respon Laporan Masuk: tombol hapus (ikon tempat sampah) di kolom Action untuk Admin & HRD, juga di tampilan kartu. Ada konfirmasi sebelum menghapus."
    ]
  },
  {
    "file": "1.0.33.json",
    "version": "1.0.33",
    "releasedAt": "2026-10-24",
    "required": false,
    "notes": [
      "Notifikasi untuk karyawan: kartu \"Pengajuan Anda sudah direspon\" di dashboard saat pengajuan disetujui, ditolak, dibatalkan, atau dihapus, dan saat Lapor HRD dijawab.",
      "Lencana angka di tombol Riwayat dan Lapor HRD. Ketuk notifikasi untuk langsung membuka layar terkait; notifikasi otomatis tertandai dibaca.",
      "Aplikasi yang dibiarkan terbuka memeriksa notifikasi baru saat kembali ke depan (paling cepat tiap 10 menit)."
    ]
  },
  {
    "file": "1.0.32.json",
    "version": "1.0.32",
    "releasedAt": "2026-10-21",
    "required": true,
    "notes": [
      "Pengajuan e-Form (Ijin, Sakit, Cuti, Cuti EO, Standby, Off, Tukar Shift, Lembur) tidak bisa lagi untuk tanggal di periode yang sudah ditutup. Contoh: mulai 21 Okt 2026, tanggal 20 Okt 2026 ke bawah (periode 21 Sep–20 Okt) terkunci.",
      "Kalender pilih tanggal menandai tanggal periode lalu sebagai terkunci dan tidak bisa mundur ke bulan sebelum periode berjalan.",
      "Lapor HRD: tanggal koreksi (tunggal, rentang, maupun beberapa tanggal) juga hanya bisa dipilih dari periode berjalan."
    ]
  },
  {
    "file": "1.0.31.json",
    "version": "1.0.31",
    "releasedAt": "2026-10-19",
    "required": true,
    "notes": [
      "Dinas Luar (DL) kini sama dengan Absen Online: selfie kamera depan + lokasi GPS + keterangan dinas, tanpa memilih tanggal/jam. Tanggal otomatis hari ini dan langsung terverifikasi.",
      "Lapor HRD: kategori baru 'Lupa Pengajuan Dinas Luar (DL)' — pilih tanggal dinas, wajib lampirkan foto kegiatan dinas dan keterangan.",
      "Respon HRD untuk laporan lupa DL: pilihan 'Setujui & catat DL' langsung mencatat DL pada tanggal laporan.",
      "Laporan & Cetak Data: DL yang terverifikasi bisa dibatalkan lewat tombol Edit."
    ]
  },
  {
    "file": "1.0.30.json",
    "version": "1.0.30",
    "releasedAt": "2026-10-19",
    "required": true,
    "notes": [
      "Laporan & Cetak Data: tombol Edit di kolom ACTION untuk baris Approved — admin/HRD bisa membatalkan approval menjadi Rejected dengan keterangan wajib.",
      "Kolom KETERANGAN baru (alasan approve/tolak/pembatalan) di tabel, Excel, dan PDF.",
      "Tombol Approve/Reject di laporan memakai jendela keterangan, bukan dialog konfirmasi."
    ]
  },
  {
    "file": "1.0.29.json",
    "version": "1.0.29",
    "releasedAt": "2026-09-19",
    "required": true,
    "notes": [
      "Tombol Refresh Data dan Coba Muat Ulang Data berfungsi kembali. Keduanya sempat menampilkan pesan 'Gagal terhubung ke Web App' padahal server tidak pernah dihubungi.",
      "Rekapitulasi membuka periode aktif secara otomatis, tidak lagi menarik seluruh isi dbabsen setiap kali dibuka.",
      "Tombol Koreksi tersedia langsung di baris Dashboard dan Tabel Data (DB_FIX); baris yang sudah terkoreksi membuka koreksinya untuk diubah, bukan menumpuk koreksi baru."
    ]
  },
  {
    "file": "1.0.28.json",
    "version": "1.0.28",
    "releasedAt": "2026-09-18",
    "required": false,
    "notes": [
      "Tidak ada perubahan pada aplikasi. Versi dinaikkan mengikuti perbaikan di sisi server."
    ]
  },
  {
    "file": "1.0.27.json",
    "version": "1.0.27",
    "releasedAt": "2026-09-18",
    "required": false,
    "notes": [
      "Tidak ada perubahan pada aplikasi. Versi dinaikkan mengikuti perbaikan di sisi server."
    ]
  },
  {
    "file": "1.0.26.json",
    "version": "1.0.26",
    "releasedAt": "2026-09-18",
    "required": false,
    "notes": [
      "Tidak ada perubahan pada aplikasi. Versi dinaikkan mengikuti perbaikan di sisi server."
    ]
  },
  {
    "file": "1.0.25.json",
    "version": "1.0.25",
    "releasedAt": "2026-09-18",
    "required": true,
    "notes": [
      "Layar dashboard kini muncul segera setelah login dijawab, tidak lagi menunggu seluruh statistik selesai dihitung di server.",
      "Angka statistik, pengumuman, dan lonceng approval menyusul di latar belakang lewat satu permintaan, tanpa menahan layar.",
      "Lama permintaan login dicatat ke console browser, sehingga penyebab 'login lama' bisa dipisahkan antara server, jaringan, dan gerbang lokasi."
    ]
  },
  {
    "file": "1.0.24.json",
    "version": "1.0.24",
    "releasedAt": "2026-09-18",
    "required": true,
    "notes": [
      "Membuka aplikasi jauh lebih cepat: lima permintaan terpisah ke server (cek versi, statistik, pengumuman, status pelacakan lokasi, dan angka approval) digabung menjadi SATU permintaan.",
      "Angka dashboard kini sudah ikut dalam balasan login, sehingga layar utama tidak lagi menunggu satu permintaan tambahan setelah masuk.",
      "Pelacak lokasi dan lonceng approval tidak lagi menembak permintaannya sendiri saat aplikasi dibuka — datanya sudah dibawa dari awal.",
      "Bila server lama masih terpasang, aplikasi otomatis kembali ke cara lama. Tidak ada urutan deploy yang wajib."
    ]
  },
  {
    "file": "1.0.23.json",
    "version": "1.0.23",
    "releasedAt": "2026-09-15",
    "required": true,
    "notes": [
      "Import data mesin tidak lagi gagal total hanya karena satu potongan kebetulan dibalas halaman oleh server Google: potongan itu kini dikirim ulang otomatis sampai tiga kali.",
      "Import berukuran besar paling terasa manfaatnya — satu berkas 4.500 baris terpecah menjadi 12 potongan, dan sebelumnya cukup satu potongan bermasalah untuk membatalkan seluruhnya.",
      "Bila ketiga percobaan tetap gagal, pesannya kini menyebutkan dengan pasti bahwa sheet tujuan belum tersentuh dan import aman diulang dari awal."
    ]
  },
  {
    "file": "1.0.22.json",
    "version": "1.0.22",
    "releasedAt": "2026-09-15",
    "required": true,
    "notes": [
      "Karyawan yang bekerja di komputer tanpa GPS kini dapat dikecualikan dari gerbang lokasi oleh Admin, lewat Panel Admin > Geofence. Menu terbuka tanpa menunggu lokasi dan tombol Kirim tidak lagi menahan.",
      "Pesan pada layar gerbang dibedakan untuk komputer: komputer tidak punya GPS, posisinya ditebak dari jaringan WiFi di sekitar, sehingga PC berkabel selalu gagal — sebelumnya karyawan disuruh mencari sinyal GPS yang memang tidak ada.",
      "Keadaan baru dikenali: permintaan lokasi yang tidak pernah dijawab browser, biasanya karena dialog izin masih menggantung atau izin lokasi situs sedang diblokir. Sebelumnya layar hanya berputar tanpa penjelasan.",
      "Tombol Keluar dari akun kini juga tersedia selama pemeriksaan lokasi berlangsung, sehingga layar itu tidak pernah lagi menjadi jalan buntu."
    ]
  },
  {
    "file": "1.0.21.json",
    "version": "1.0.21",
    "releasedAt": "2026-09-14",
    "required": true,
    "notes": [
      "Membuka aplikasi lebih cepat: pengecekan versi ke server tidak lagi dijalankan sebagai permintaan terpisah saat layar login, karena informasi versinya sudah ikut dalam balasan login.",
      "Foto absen dikecilkan ke maksimal 1280 piksel sebelum dikirim, sehingga menekan Kirim jauh lebih cepat di jaringan seluler. Ketelitian pencocokan wajah tidak berubah — pemeriksaan wajah tetap memakai gambar resolusi penuh.",
      "Stempel waktu dan alamat pada foto tetap terbaca dengan ukuran yang sama proporsionalnya."
    ]
  },
  {
    "file": "1.0.20.json",
    "version": "1.0.20",
    "releasedAt": "2026-09-11",
    "required": true,
    "notes": [
      "Pengajuan Standby kini wajib menyertakan foto, dan fotonya harus diambil langsung dari kamera depan — tombol ganti kamera tidak lagi muncul pada form ini.",
      "Foto Standby dicocokkan dengan wajah acuan karyawan seperti presensi Masuk & Pulang: hasil pencocokan tampil sebelum tombol Kirim ditekan, dan wajah yang bukan pemilik akun ditolak.",
      "Tombol Kirim pada form Standby tidak aktif selama foto belum diambil atau wajah belum terverifikasi."
    ]
  },
  {
    "file": "1.0.19.json",
    "version": "1.0.19",
    "releasedAt": "2026-09-11",
    "required": true,
    "notes": [
      "Satu akun kini hanya aktif di satu perangkat: login dari HP lain otomatis mengakhiri sesi di HP sebelumnya, dengan pesan yang menyebutkan alasannya.",
      "Setiap HP mendapat identitas tetap dan terikat ke akun pemakainya; HP yang dipakai akun lain tercatat dan terlihat di Panel Admin.",
      "Admin dapat menaikkan kuota akun per perangkat, untuk HP milik PIC yang memang mengabsenkan timnya.",
      "Presensi Masuk & Pulang kini mencocokkan wajah dengan wajah acuan karyawan; wajah yang bukan pemilik akun ditolak dan fotonya dibuang.",
      "Pencocokan dilakukan di server — data wajah acuan tidak pernah dikirim ke HP, sehingga tidak dapat ditiru dari sisi aplikasi.",
      "Hasil pencocokan ditampilkan sebelum tombol Kirim ditekan, jadi karyawan tahu lebih awal bila harus mengambil ulang foto.",
      "Model pengenal wajah diunduh di latar saat kamera dibuka, sehingga tidak menambah waktu tunggu sebelum memotret.",
      "Pengajuan Dinas kini terkunci pada kamera depan, tetapi tetap boleh memuat lebih dari satu orang dalam satu foto.",
      "Penolakan Fake GPS pada presensi Masuk & Pulang dikembalikan: koordinat yang tidak bergeser sama sekali pada beberapa pembacaan GPS berbeda kembali menolak kiriman di perangkat."
    ]
  },
  {
    "file": "1.0.18.json",
    "version": "1.0.18",
    "releasedAt": "2026-09-10",
    "required": true,
    "notes": [
      "Sesi kini bertahan 60 menit sejak aktivitas terakhir (sebelumnya 5 menit), sehingga aplikasi yang hanya dibiarkan terbuka tidak lagi keluar sendiri di tengah jam kerja.",
      "Pelacakan posisi tetap berjalan selama aplikasi standby: layar ditahan agar tidak mati sendiri selama pelacakan aktif, dan siklus pengiriman tidak lagi dilewati saat aplikasi berada di latar belakang.",
      "Titik posisi yang gagal terkirim karena sinyal hilang kini disimpan di perangkat dan disusulkan otomatis begitu jaringan kembali, sehingga jejak perjalanan tidak berlubang.",
      "Pesan sesi berakhir menyebutkan durasi yang benar-benar berlaku (sebelumnya selalu tertulis 10 menit).",
      "Perbaikan salah tuduh “Mock GPS”: dua pembacaan GPS yang sebenarnya berasal dari satu fix yang sama (timestamp identik) tidak lagi dianggap sebagai koordinat beku.",
      "Pengambilan sampel lokasi kini memakai watchPosition dan hanya menghitung fix dengan timestamp berbeda, dengan batas waktu 3,5 detik agar form absen tidak menggantung.",
      "Badge merah “Mock GPS” hanya muncul untuk sinyal keras (flag Mock Location dari sistem, mode otomasi, koordinat 0,0, akurasi 0 m, presisi koordinat terlalu rendah)."
    ]
  },
  {
    "file": "1.0.17.json",
    "version": "1.0.17",
    "releasedAt": "2026-09-09",
    "required": true,
    "notes": [
      "Presensi Masuk & Pulang kini terkunci pada KAMERA DEPAN; kamera belakang ditolak beserta pesan penjelasannya.",
      "Verifikasi wajah penuh sebelum foto dapat diambil: wajah harus utuh (dahi sampai dagu), menghadap lurus, satu orang, dan tidak tertutup.",
      "Pemeriksaan ulang wajah pada foto yang benar-benar dijepret, sehingga kamera tidak bisa dialihkan sesaat sebelum menjepret.",
      "Pembaruan aplikasi kini dipaksa: HP yang masih memakai versi lama otomatis mendeteksi versi baru di server, membersihkan cache, dan memuat ulang sendiri.",
      "Sisa Service Worker dan Cache Storage dari rilis lama dibersihkan saat aplikasi dibuka, sehingga cukup me-refresh halaman untuk mendapatkan perubahan terbaru."
    ]
  },
  {
    "file": "1.0.16.json",
    "version": "1.0.16",
    "releasedAt": "2026-09-08",
    "required": true,
    "notes": [
      "Lokasi perangkat kini wajib aktif: menu tidak terbuka sebelum GPS terbaca, lengkap dengan panduan pengaktifan per perangkat.",
      "Pelacakan posisi karyawan selama aplikasi terbuka dan Dashboard GPS berpeta untuk admin.",
      "Perbaikan layar putih dan layar update berulang di Safari iOS serta Chrome Android."
    ]
  },
  {
    "file": "1.0.15.json",
    "version": "1.0.15",
    "releasedAt": "2026-08-17",
    "required": true,
    "notes": [
      "Perbaikan geofence, validasi sesi, dan penyegaran tampilan aplikasi mobile."
    ]
  },
  {
    "file": "1.0.14.json",
    "version": "1.0.14",
    "releasedAt": "2026-08-12",
    "required": true,
    "notes": [
      "Performa pembukaan aplikasi ditingkatkan dengan membawa statistik dan pengumuman bersama respons login."
    ]
  }
];
